import { Grid, Card, Typography, LinearProgress, Box } from '@mui/material';
import 'react-circular-progressbar/dist/styles.css';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const SummaryZonesPieCard = ({ summaryZones }) => {
    return (
        <Grid container spacing={2}>
            {summaryZones.map((zone, index) => {
                const isFirst = index === 0;
                const isLast = index === summaryZones.length - 1;

                let rangeText = '';
                if (isFirst) rangeText = `< ${zone.max} bpm`;
                else if (isLast) rangeText = `> ${zone.min} bpm`;
                else rangeText = `${zone.min} - ${zone.max} bpm`;

                return (
                    <Grid item xs={12} sm={4} key={index}>
                        <Card sx={{ p: 2, textAlign: 'center' }}>
                            <Typography variant="h3" gutterBottom>
                                {zone.label}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                {Math.round(zone.value)}%
                            </Typography>
                            <LinearProgress
                                variant="determinate"
                                value={zone.value}
                                sx={{
                                    height: 12,
                                    borderRadius: 6,
                                    mb: 1,
                                    backgroundColor: '#eee',
                                    '& .MuiLinearProgress-bar': {
                                        backgroundColor: zone.color
                                    }
                                }}
                            />
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 0.5
                                }}
                            >
                                <AccessTimeIcon fontSize="small" /> {zone.time}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                {rangeText}
                            </Typography>
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default SummaryZonesPieCard;
